import { registerLocale, getNames } from 'i18n-iso-countries';
import en from 'i18n-iso-countries/langs/en.json';
import fr from 'i18n-iso-countries/langs/fr.json';
import es from 'i18n-iso-countries/langs/es.json';
import { useLanguageContext } from '../components/contexts/LanguageContext';
import { PROVINCES } from '../constants/provinces';

registerLocale(en);
registerLocale(fr);
registerLocale(es);

const getNameAndCodeFromEntry = (entry) => ({ code: entry[0], name: entry[1] });

const fallbackLang = 'en';
const canadaCode = 'CA';

export const useSelectCountry = () => {
  const { language } = useLanguageContext();

  const countriesObj = getNames(language) || getNames(fallbackLang);
  const countries = Object.entries(countriesObj).map(getNameAndCodeFromEntry);

  const provincesObj = PROVINCES[language] || PROVINCES[fallbackLang];
  const provinces = Object.entries(provincesObj).map(getNameAndCodeFromEntry);

  const getProvincesForCountry = (countryCode) =>
    countryCode === canadaCode ? provinces : [];

  return {
    countries,
    provinces,
    getProvincesForCountry,
  };
};
